import { useEffect, useState, useRef } from 'react';
import { SearchableSelect } from '../../design-system';
import { useSaveFilters, useYardOptionsQuery } from '../../hooks';
import { i18n } from '../../i18n';
import { useStoreUser } from '../../context';
import { showToRoles } from '../../utils';
import { INPUT_ERRORS } from '../../const';

interface BelongsToFilterSelectsProps {
  handleChange: (obj: any) => void;
}

export const BelongsToFilterSelects: React.FC<BelongsToFilterSelectsProps> = ({
  handleChange,
}: BelongsToFilterSelectsProps) => {
  const { user } = useStoreUser();

  const [oldFilters, setOldFilters] = useSaveFilters('belongs-to', true);

  const yardCompanyId = useRef(user?.yardCompanyEmployee?.yardCompanyId);
  const [yardName, setYardName] = useState(oldFilters.yardName);
  const yardId = useRef(oldFilters.yardId);

  const { data: yardQuery } = useYardOptionsQuery(
    [
      'yard-short',
      'assigned-yards' +
        (showToRoles(['YARD_COMPANY_ADMIN', 'YARD_COMPANY_EMPLOYEE', 'YARD_COMPANY_VIEWER'], user)
          ? yardCompanyId.current
          : ''),
    ],
    {
      user,
      yardCompanyId: yardCompanyId.current,
    },
  );

  const handleYardSelect = (obj: any) => {
    const otherData: any = {};

    yardId.current = obj.id;
    setYardName(obj.label);

    const data = { yardId: obj.id, ...otherData };
    setOldFilters({ ...oldFilters, yardName: obj.label, ...data });
    handleChange && handleChange(data);
  };

  useEffect(() => {
    if (
      yardId.current ||
      yardQuery.yard.length !== 1 ||
      !showToRoles(['YARD_COMPANY_ADMIN', 'YARD_COMPANY_EMPLOYEE', 'YARD_COMPANY_VIEWER'], user)
    )
      return;

    handleYardSelect(yardQuery.yard[0]);
  }, [user.type, yardQuery.yard]);

  return (
    showToRoles(
      ['SUPER_ADMIN', 'YARD_COMPANY_ADMIN', 'YARD_COMPANY_EMPLOYEE', 'YARD_COMPANY_VIEWER'],
      user,
    ) && (
      <SearchableSelect
        selectedOptionLabel={yardName}
        label={i18n.t('common.yard')}
        onSelect={handleYardSelect}
        options={yardQuery.yard}
        selectedAreasEqaul={{ key: 'id', keys: [yardName] }}
        withClearButton
        helperText={!yardId.current ? INPUT_ERRORS.REQUIRED.YARD_NAME : ''}
        error={!yardId.current}
      />
    )
  );
};
